import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LinearProgress } from "@mui/material";

import { HeaderComponent } from "../../../../components/header/header.component";
import { PrudnaWidgetComponent } from "../candidate-home/components/prudna-widget/prudna-widget.component";
import Svg404 from "../../../../components/error-state/no_content.svg";
import { useRequest } from "ahooks";
import { fetchPrudnaAssessments } from "../../network/network";
import { GlobalHelper } from "../../../../utils/helpers/global-helper";
import { ErrorStateBlock } from "../../../../components/error-state/error-state";
import styles from "./prudna-history.module.css";
//PHKL Custom -s
import { useCanGoBack } from "../../../../utils/hooks/use-can-go-back";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
//PHKL Custom -e

export const PrudnaHistoryPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate(); //PHKL Custom
  const candidateId = GlobalHelper.getTokenUserSub();
  const { data, error, loading } = useRequest(() => fetchPrudnaAssessments(candidateId));
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const canGoBack = useCanGoBack(); //PHKL Custom
  return (
    <div className={`${styles.profileContainer} flex flex-col min-h-screen overflow-x-hidden`}>
      {isPortrait ? (
        <HeaderComponent title={t("Recruitment.prudna_records")} />
      ) : (
        <span className={styles.tips}>
          {/* PHKL Custom -s */}
          <ArrowBack
            style={{ cursor: "pointer", fontSize: 40, paddingRight: 10 }}
            onClick={() => {
              if (canGoBack()) {
                navigate(-1);
              }
            }}
          />
          {/* PHKL Custom -e */}
          {t("Recruitment.prudna_records")}
        </span>
      )}

      <div
        className={`${styles.content} bg-[#F4F4F4] flex-1 flex flex-col items-center gap-y-3 py-3`}
      >
        {loading ? (
          <LinearProgress className="w-full" />
        ) : error ? (
          <ErrorStateBlock statusCode={(error as any)?.status} />
        ) : data?.data && data.data.length > 0 ? (
          data.data.map((assessment: any, index: number) => (
            <PrudnaWidgetComponent key={index} assessment={assessment} />
          ))
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center">
            <img src={Svg404} width={180} height={180} alt="no_content" />
            <span className="text-center text-base font-medium text-[#858585]">
              {t("Recruitment.no_prudna_record_message")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
